import "@fortawesome/fontawesome-pro/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
    values: {
      add: "fa-plus",
      edit: "fa-pen",
      delete: "fa-trash-alt",
      check: "fa-check",
      copy: "fa-copy",
      phone: "fa-phone-square",
      reply: "fa-reply",
      close: "fa-times",
      contactInfo: "fa fa-address-book",
      search: "fa-search",
      paperclip: "fa-paperclip",
      emailOpen: "fa-envelope-open",
      emailClosed: "fa-envelope",
      stopwatch: "fa-stopwatch",
      view: "fa-list",
      exclamation: "fa-exclamation-circle",
      roster: "fa-user-friends",
      comment: "fa-comment",
      numList: "fa-list-ol",
      print: "fa-print",
      receipt: "fa-receipt",
      file: "fa-file",
      link: "fa-link",
      fileUp: "fa-file-arrow-up",
      user: "fa-user",
      dots: "fa-grip-dots-vertical",
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#007ac3",
        secondary: "#4cbcff",
        accent: "#3399cc",

        success: "#51A351",
        error: "#b71c1c",
        info: "#2F96B4",
        warning: "#F89406",
      },
    },
  },
});
